import { render, staticRenderFns } from "./ReadyforTask.vue?vue&type=template&id=5394707d&scoped=true&"
import script from "./ReadyforTask.vue?vue&type=script&lang=js&"
export * from "./ReadyforTask.vue?vue&type=script&lang=js&"
import style0 from "./ReadyforTask.vue?vue&type=style&index=0&id=5394707d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394707d",
  null
  
)

export default component.exports